var $ = require("jquery");
var DropdownManager = require("../../navigation/js/dropdownManager");
var $window = $(window);
var $pencilBanner = $('[data-pencil-banner]');

var selectors = {
    dropdownTrigger: '[data-dropdown-trigger]',
    navigation: '[data-navigation]'
};

var classes = {
    navigationActive: 'is-active',
    navigationFixed: 'is-fixed'
};

/**
* Navigation Constructor
* @param {HTMLElement} container
*/
function Navigation(container) {
    container = container || "body";

    var _this = this;

    this.$container = $(container);
    this.$el = $(selectors.navigation, this.$container);


    this.name = 'navigation';
    this.namespace = '.' + this.name;
    this.dropdownManager = new DropdownManager();

    this.events = {
        SCROLL: 'scroll' + this.namespace
    };

    // Construct a new dropdown from each trigger and add to our array of dropdowns to keep track
    var $dropdowns = this.$el.find(selectors.dropdownTrigger);
    $dropdowns.each(function (i, trigger) {
        _this.dropdownManager.register($(trigger));
    });

    this.$el.on('pointerenter mouseenter', this.onMouseEnter.bind(this));
    this.$el.on('pointerleave mouseleave', this.onMouseLeave.bind(this));

    $window.on(this.events.SCROLL, this.onScroll.bind(this));
    this.onScroll(); // hit this one time on init to make sure everything is good

    // Handle special "Hero Short adjacent case"
    if (this.isNotTransparent()) {
        this.$el.addClass(classes.navigationActive);
    }
};

Navigation.prototype = $.extend({}, Navigation.prototype, {

    scrollCheck: function () {
        var $pb = $pencilBanner;
        var scrollTop = $window.scrollTop();

        // If ticker is there we haven't scrolled past it... OR we're at the very top of the page
        if (($pb.length && scrollTop < $pb.outerHeight()) || scrollTop == 0) {
            this.$el.removeClass(classes.navigationFixed);
        } else {
            this.$el.addClass(classes.navigationFixed);
        }
    },

    onScroll: function () {
        this.scrollCheck();
    },

    onMouseEnter: function () {
        this.$el.addClass(classes.navigationActive);
    },

    onMouseLeave: function () {
        this.dropdownManager.closeAllDropdowns();

        if (this.isNotTransparent()) return;

        this.$el.removeClass(classes.navigationActive);
    },


    // NOTE: Reaching outside of scope.
    //      We have to handle a special case when this module is adjacent
    //      to a hero module that's also a .hero--short variation
    isNotTransparent: function () {
        var selectors = [
            ".hero__wrapper > .hero--short",
            ".cms_plugin + .hero__wrapper > .hero--short",
            ".hero--no-transparent-nav",
            ".cms_plugin + .hero--no-transparent-nav"
        ]
        var $result = $(selectors.join(", "));
        return $result.length;
    }
});

module.exports = Navigation;



//////////////////
// WEBPACK FOOTER
// ./navigation/js/navigation.js
// module id = 140
// module chunks = 3